import { createContext, useContext } from 'react';

/**
 * Transient alignment guides for one freeform canvas. While an element is
 * dragged it snaps its edges/centers to sibling elements and the canvas
 * centre/edges (Figma-style) and reports the guide lines to draw. Coordinates
 * are in design px (same space the elements are positioned in). UI-only, never
 * synced.
 */
export interface GuideLine {
  /** 'v' = vertical line at constant x; 'h' = horizontal line at constant y. */
  axis: 'v' | 'h';
  /** x (for 'v') or y (for 'h') in design px. */
  pos: number;
  /** Line extent along the cross axis (design px) — start/end so it spans only
   *  between the aligned elements, like Figma. */
  start: number;
  end: number;
}

export type SnapGuides = GuideLine[];

export const FreeformSnapContext = createContext<{ setGuides: (g: SnapGuides) => void } | null>(
  null,
);

export function useFreeformSnap() {
  return useContext(FreeformSnapContext);
}
